import React, { useEffect } from "react";

import { googleMapKey } from "../../variables/apikeys";
import {Card, CardHeader, CardTitle, CardBody, Col, Row, Button, FormGroup, Input, Label, Alert} from "reactstrap";
import { colors, opacities, borderWeights, getIcon, MODE_GRAB, MODE_MARKER, MODE_POLYGON, aryAlphabet, encodeArrayPoints } from "../../variables/maps";
import { object, reject } from "underscore";
//import { google } from "../../common/StaticMap";
import {
    Modal,
    ModalBody,
    ModalFooter,
} from "reactstrap";

import Request from "../../common/Request";

import {CopyToClipboard} from 'react-copy-to-clipboard';

import {GetMessage, waypointMaxCount, urlMaxLength} from '../../variables/message';

import Common from '../../common/Common';

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

//export const baseMapSize = {width:640, height: 480}
export const baseMapSize = {width:640, height: 600}

export default class MapViews extends React.Component {

    constructor (props) {
        super(props);
        this.state = {
            view_index: 0,
            modal_monochrome_map : false,
            confirm_map_url: false,
            modal_map_index: 0,
            googleMaps: {
                map: null,
                window: []
            },
            mounted :true,
            request_data: this.props.request_data,
            map_settings: {
                center : {
                    lat: this.props.request_data? this.props.request_data.latitude : 35.68370098971363,
                    lng: this.props.request_data? this.props.request_data.longitude : 139.7004348630834
                },
                zoom: 18,
            },
            map_data : [...this.onParkingDrawData()],
            flagged_parkings : this.props.flagged_parkings? [...this.props.flagged_parkings]: [],
            error:[],
            url_error: false,
            waypoint_error : false, 
        }

        this.map = null;
        this.pli_cursor = null;
        // ウィジット移動情報
        this.selectWidget = {
            selecting: false,
            type: null, // distinates_marker 目的地, memo メモ, polygon 図形
            widget: null,
            index: null,
            data: {} // typeごとの付加情報
        }

        this.loadMapView = this.loadMapView.bind(this);
        this.onchangeMemo = this.onchangeMemo.bind(this);
        this.drawDirections = this.drawDirections.bind(this);
        this.onChangeHandle = this.onChangeHandle.bind(this);
        this.onClickHandle = this.onClickHandle.bind(this);
        this.onClickMapHandle = this.onClickMapHandle.bind(this);
        this.controller = this.controller.bind(this);
        this.parkingDetail = this.parkingDetail.bind(this);
        this.save = this.save.bind(this);
        // this.addMarker = this.addMarker.bind(this);
        this.addSvgPinMarker = this.addSvgPinMarker.bind(this);
        this.addDistinateMarker = this.addDistinateMarker.bind(this);
        this.addFlaggedParkingMarker = this.addFlaggedParkingMarker.bind(this);
        this.addMakerImage = this.addMakerImage.bind(this);
        this.addMemo = this.addMemo.bind(this);
        this.addPolygon = this.addPolygon.bind(this);
        this.deleteMemo = this.deleteMemo.bind(this);
        this.convert_object_marker = this.convert_object_marker.bind(this);
        this.convert_uri_marker = this.convert_uri_marker.bind(this);
        this.convert_object_direction = this.convert_object_direction.bind(this);
        this.convert_uri_direction = this.convert_uri_direction.bind(this);
        this.convert_object_polygon = this.convert_object_polygon.bind(this);
        this.convert_uri_polygon = this.convert_uri_polygon.bind(this);
        this.convert_object_memo = this.convert_object_memo.bind(this);
        this.convert_uri_memo = this.convert_uri_memo.bind(this);
        this.convert_map_param = this.convert_map_param.bind(this);
        this.onchangeMapIndex = this.onchangeMapIndex.bind(this);
        this.urlValidate = this.urlValidate.bind(this);
    }

    setSelectWidget(type, widget, index, data = {}) {
        this.selectWidget.selecting = true
        this.selectWidget.type = type
        this.selectWidget.widget = widget
        this.selectWidget.index = index
        this.selectWidget.data = data
    }

    selectDistinatesMarker(widget, index) {
        this.setSelectWidget('distinates_marker', widget, index)
    }
    selectMemo(marker_widget, index, popup_widget) {
        this.setSelectWidget('memo', marker_widget, index, {popup_widget: popup_widget})
    }
    selectPolygon(maker_widget, index, polygon, polygon_index) {
        this.setSelectWidget('polygon', maker_widget, index, {polygon: polygon, polygon_index: polygon_index})
    }
    selectPolyline(widget, index, latlng) {
        this.pli_cursor.setLatLng(latlng);
        this.pli_cursor.show();
        this.setSelectWidget('polyline', widget, index)
    }
    clearSelectWidget() {
        this.pli_cursor.hide();
        if(!this.selectWidget.selecting) return
        this.selectWidget = {
            selecting: false,
            type: null,
            widget: null,
            index: null,
            data: {}
        }
    }

    selectWidgetMoveEnd(latlng) {
        let view_index = this.state.view_index
        let map_data = this.state.map_data[view_index]
        let index = this.selectWidget.index;
        // console.log(map_data)
        switch(this.selectWidget.type) {
            case 'distinates_marker':
                // マーカを移動する
                this.selectWidget.widget.setLatLng(latlng)
                map_data.coordinates.distinates[index].lat = latlng.lat;
                map_data.coordinates.distinates[index].lng = latlng.lng;
                // 再ルート検索
                {
                    const start = map_data.coordinates.start;
                    const relay_points = map_data.coordinates.relay_points[index];
                    let pli = map_data.objects.route_polylines[this.selectWidget.index]
                    this.reroute(start, latlng, relay_points, (latlngs) => {
                        pli.setShape(latlngs)
                    })
                }
                break;
            case 'memo':
                // マーカを移動する
                this.selectWidget.widget.setLatLng(latlng)

                // 吹き出しを移動する
                this.selectWidget.data.popup_widget.setLatLng(latlng)
                break;
            case 'polygon':
                // マーカを移動する
                this.selectWidget.widget.setLatLng(latlng)

                // 図形再描画
                let polygon = this.selectWidget.data.polygon
                polygon.latlngs[this.selectWidget.index] = latlng
                if(polygon.polygon_widget != null) {
                    polygon.polygon_widget.setShape(polygon.latlngs)
                }
                break;
            case 'polyline':
                map_data.coordinates.relay_points[index].push(latlng);
                // 再ルート検索
                {
                    const start = map_data.coordinates.start;
                    const end = map_data.coordinates.distinates[index];
                    const relay_points = map_data.coordinates.relay_points[index];
                    let pli = map_data.objects.route_polylines[this.selectWidget.index]
                    this.reroute(start, end, relay_points, (latlngs) => {
                        pli.setShape(latlngs)
                    }, () => {
                        map_data.coordinates.relay_points[index].pop()
                    })
                }
                // console.log(map_data.coordinates.relay_points)
                break;
        }
        this.clearSelectWidget()
    }


    onParkingDrawData () {
        if (this.props.parking_objects) {
            let data_with_options = this.props.parking_objects.map((obj, index)=>{
                let coordinates = obj.map(parking=>{
                    return({
                        data: parking,
                        lat: parking.latitude,
                        lng: parking.longitude
                    })
                })
                let relay_points = [];
                coordinates.forEach(() => {
                    relay_points.push([]);
                })

                return ({
                    isload: false,
                    edit_mode: MODE_POLYGON,
                    map_settings: {},
                    objects : {
                        distinates_markers : [], // 目的地アイコン
                        markers : [],
                        polygons : [],
                        memos: [],
                        route_polylines: []
                    },
                    settings : {
                        polygonIndex: 0
                    },
                    // 緯度経度情報
                    coordinates : { 
                        // 現場
                        start : {
                            lat: this.props.request_data? this.props.request_data.latitude : 35.68370098971363,
                            lng: this.props.request_data? this.props.request_data.longitude : 139.7004348630834
                                },
                        relay_points: relay_points,
                        distinates: [...coordinates]
                    },
                    // 経路描画用設定
                    map_drawer_options : {
                        draggable: true,
                        preserveViewport: true,
                        markerOptions: true,
                        suppressMarkers: true,
                        polylineOptions: {
                            strokeColor:colors[1].value,
                            strokeOpacity:opacities[1].value,
                            strokeWeight:borderWeights[2].value
                        },
                    },
                    direction_stroke_options: [
                        {
                            draggable: true,
                            preserveViewport: true,
                            markerOptions: true,
                            suppressMarkers: true,
                            polylineOptions: {
                                strokeColor:colors[0].value,
                                strokeOpacity:opacities[1].value,
                                strokeWeight:borderWeights[5].value
                            }
                        },
                        {
                            draggable: true,
                            preserveViewport: true,
                            markerOptions: true,
                            suppressMarkers: true,
                                polylineOptions: {
                                strokeColor:colors[1].value,
                                strokeOpacity:opacities[1].value,
                                strokeWeight:borderWeights[5].value
                            }
                        },
                        {
                            draggable: true,
                            preserveViewport: true,
                            markerOptions: true,
                            suppressMarkers: true,
                                polylineOptions: {
                                strokeColor:colors[2].value,
                                strokeOpacity:opacities[1].value,
                                strokeWeight:borderWeights[5].value
                            }
                        },
                    ],
                    // 図形描画用設定
                    polygon_drawer_options : {
                        draggable: true,
                        editable: true,
                        strokeColor:"#5a03fc",
                        strokeOpacity:0.8,
                        strokeWeight:2,
//                        fillColor:"#03fc6f",
                        fillColor:"#5a03fc",
                        fillOpacity:0.5,
                    },
                    child_map_options : {
                        draggable: false,
                        preserveViewport: true,
                        markerOptions: true,
                        polylineOptions: {
                            strokeColor:colors[1].value,
                            strokeOpacity:opacities[1].value,
                            strokeWeight:borderWeights[2].value
                        },
                    }
                });
            })
            return data_with_options
        }
        return null;
    }

    componentDidUpdate (prevProps,prevState) {
        let isUpdate = false;

        if ( prevProps.parking_objects != this.props.parking_objects && this.props.parking_objects != null) {
            isUpdate = true;
        }

        if ( isUpdate ) {
        }

    }
    componentDidMount () {
        Common.waitForTrue(() => typeof ZisAuth !== undefined, this.init.bind(this))
    }
    init () {
        let {
            map_data,
            map_settings
        } = this.state

        // zenrin
        ZisAuth.addEventListener("ready", function(e) {
            var mapOptions = ZisAuth.getMapOption();
            mapOptions.center = new ZDC.LatLng(map_settings.center.lat, map_settings.center.lng);
            mapOptions.zoom = map_settings.zoom;
            mapOptions.zipsMapType = 'kP8KjZdn';
            mapOptions.mouseWheelReverseZoom = true;
            this.map = new ZDC.Map(
                document.getElementById('MapDiv'),
                mapOptions,
                function () {
                    // polylineのカーソル追加
                    const svg = `
                    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
                        <circle cx="5" cy="5" r="5" fill="none" stroke="#5a03fc" stroke-width="4"></circle>
                        <!-- cx=中心のx座標 cy=中心のy座標 r=半径 -->
                    </svg>
                    `
                    const iconSvgUrl = `data:image/svg+xml,${encodeURIComponent(svg)}`;
                    this.pli_cursor = new ZDC.Marker(
                        new ZDC.LatLng(35.68370098971363, 139.7004348630834),
                        {
                            custom: {
                                base: {
                                    imgPos: new ZDC.Point(-5, -5),
                                    imgSrc: iconSvgUrl
                                }
                            },
                            propagation: true
                        }
                    );

                    this.map.addWidget(this.pli_cursor);
                    this.clearSelectWidget();

                    // Success callback
                    this.map.addControl(new ZDC.ZoomButton('top-left'));

                    /* 地図をクリックしたときの動作 */
                    this.map.addEventListener('click', (event) => {
                        // console.log(event.latlng);
                        this.clearSelectWidget();
                        this.onClickMapHandle(event);
                    });

                    this.map.addEventListener('mouseup', (e) => {
                        // console.log('mouseup')
                        if(this.selectWidget.selecting) {
                            this.selectWidgetMoveEnd(e.latlng)
                        }
                    });

                    this.map.addEventListener('mouseout', (e) => {
                        // console.log('mouseout')
                        // this.clearSelectWidget()
                    });
                    this.map.addEventListener('mouseover', (e) => {
                        // console.log('mouseover')
                        // this.clearSelectWidget()
                    });

                    this.loadMapView(0);
                }.bind(this),
                function () {
                    // Failure callback
                }.bind(this)
            );
        }.bind(this));
    }
    loadMapView (index) {
        let icon = getIcon("site");
        let mapData = this.state.map_data;
        let data = this.state.map_data[index];
        let markers = [...data.objects.markers];
        let marker = new ZDC.Marker(
            new ZDC.LatLng(data.coordinates.start.lat, data.coordinates.start.lng),
            {
                custom: {
                    base: {
                        imgSrc: icon.iconLinkUrl
                    }
                },
                propagation: true
            }
        );
        this.map.addWidget(marker);
        markers.push({
            start: true,
            marker: marker
        })
        markers = markers.concat(this.addFlaggedParkingMarker(index))

        // 経路の描画
        let direction = this.drawDirections(data, index, markers);

        mapData[index] = {
            ...data,
            isload: true,
            map_settings: this.state.map_settings,
            direction_stroke_options: direction.map(d=>{return d.draw_options}),
            objects : {
                ...data.objects,
                markers: markers,
                distinates_markers: direction.map(d=>{return d.marker}),
            }
        }
        this.setState({map_data: mapData},()=>{
            let {map_settings} = this.state.map_data[this.state.view_index];
        })
    }

    addSvgPinMarker (index, latLng, labelText, color="#8B0000") {
        let path = "M82 464 c-51 -26 -77 -70 -77 -130 0 -43 7 -62 52 -136 29 -47 60 -105 68 -129 9 -24 18 -51 21 -59 3 -9 13 8 23 41 10 32 42 95 70 142 61 99 72 147 46 201 -35 73 -131 106 -203 70z"
        let size = { width: 30, height: 48}
        const svg = `<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="${size.width}pt" height="${size.height}pt" viewBox="0 0 ${size.width} ${size.height}" preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,${size.height}.000000) scale(0.100000,-0.100000)" fill="${color}" stroke="none">
        <path d="${path}" />
        </g><text style="fill: #FFFFFF" x="${size.width/2}" y="${size.height/2-3}" text-anchor="middle">${labelText}</text></svg>`
        const iconSvgUrl = `data:image/svg+xml,${encodeURIComponent(svg)}`;

        let marker = new ZDC.Marker(
            new ZDC.LatLng(latLng.lat, latLng.lng),
            {
                custom: {
                    base: {
                        imgPos: new ZDC.Point(((size.width / 2) * -1) - 5, (size.height * -1) - 15), // 位置微調整
                        imgSrc: iconSvgUrl
                    }
                }
            }
        );
        this.map.addWidget(marker);
        return marker
    }


    addDistinateMarker (index, subIndex, latLng, labels, options={}) {
        let {
            distinates_markers
        } = this.state.map_data[index].objects;
        let marker;

        if (distinates_markers[subIndex]) {
            marker = distinates_markers[subIndex]
            marker.setOptions({
                ...marker.getOptions(),
                label: {
                    text: labels.text,
                    color: labels.color? labels.color: "#FFFFFF",
                    fontSize: labels.fontSize? labels.fontSize: "20px"
                }
            })
        }
        else {
            let cnt = index * 3 + subIndex

            marker = this.addSvgPinMarker(index, latLng, aryAlphabet[cnt], options.fillColor)
            marker.addEventListener("mousedown", (e) => {
                // console.log('select distinate marker ' + subIndex)
                this.selectDistinatesMarker(marker, subIndex)
            })
            marker.addEventListener("mouseup", (e) => {
                this.clearSelectWidget()
            })
        }

        return marker;
    }

    addFlaggedParkingMarker (index) {

        let data = this.state.map_data[index]
        let distance = 0
        data.coordinates.distinates.forEach((park)=>{
            distance = (parseInt(park.data.site_distance_meter)<distance)? distance: parseInt(park.data.site_distance_meter)
        })
        let viewFlaggedParking = this.state.flagged_parkings

        let markers = []
        // console.log(this.state.flagged_parkings)
        // 経路図表示設定の駐車場を地図にマーカ表示する
        if (viewFlaggedParking) {
            viewFlaggedParking.forEach((p,n)=>{
                let flagsIcon = getIcon("png-"+p.request_parking_status)
                let marker = new ZDC.Marker(
                    new ZDC.LatLng(p.latitude, p.longitude),
                    {
                        custom: {
                            base: {
                                imgSrc: flagsIcon.iconLinkUrl
                            }
                        },
                        propagation: true
                    }
                );
                this.map.addWidget(marker);
                markers.push({
                    start: false,
                    request_parking_status: p.request_parking_status,
                    marker: marker
                })
            })
        }
        // console.log(markers)
        return markers;
    }

    addMakerImage (index, latLng, imageId) {
        let icon = getIcon(imageId);

        let marker = new ZDC.Marker(
            new ZDC.LatLng(latLng.lat, latLng.lng),
            {
                custom: {
                    base: {
                        imgSrc: icon.iconLinkUrl
                    }
                }
            }
        );
        this.map.addWidget(maker);
        return marker;
    }

    addMemo (index) {
        let map_data = this.state.map_data
        let memos = map_data[index].objects.memos;

        if (memos.length >= 3) {
            return;
        }

        let nextIndex = memos.length
        let num = nextIndex + 1

        let center = this.map.getCenter()

        let marker_widget = this.addSvgPinMarker(index, center, num.toString())
        let popup_widget = new ZDC.Popup(
            center,
            {
                offset: new ZDC.Point(0, -63),
                htmlSource: "",
                closeButton: false
            }
        );
        marker_widget.addEventListener("mousedown", (e) => {
            console.log('select memo marker ' + nextIndex)
            this.selectMemo(marker_widget, nextIndex, popup_widget)
        })
        this.map.addWidget(popup_widget);

        memos.push({memo_text: "", popup_widget: popup_widget, marker_widget: marker_widget})

        map_data[index].objects.memos = memos

        this.setState({map_data: map_data})
    }

    deleteMemo(index, mIndex){

        let map_data = this.state.map_data
        let {
            memos
        } = map_data[index].objects

        let tmpError = this.state.error ? this.state.error: [];
        if(tmpError[`P${index}`] && Object.keys(tmpError[`P${index}`]).length){
            if(tmpError[`P${index}`][`M${mIndex}`]){
                delete(tmpError[`P${index}`][`M${mIndex}`]);
            }
            if(!Object.keys(tmpError[`P${index}`]).length){
                delete(tmpError[`P${index}`]);
            }else{
                switch(mIndex){
                    case 0 :
                        let key = Object.keys(tmpError[`P${index}`]);
                        key.forEach((k)=>{
                            if(k == "M1"){
                                tmpError[`P${index}`]["M0"] = tmpError[`P${index}`][k];
                            } else if (k == "M2"){
                                tmpError[`P${index}`]["M1"] = tmpError[`P${index}`][k];
                                delete(tmpError[`P${index}`][k]);
                            }
                        });
                    break;
                    case 1 :
                        tmpError[`P${index}`]["M1"] = tmpError[`P${index}`]["M2"];
                        delete(tmpError[`P${index}`]["M2"]);
                        break;
                }    
            }

        }

        this.map.removeWidget(memos[mIndex].popup_widget)
        this.map.removeWidget(memos[mIndex].marker_widget)
        memos.splice(mIndex, 1)

        memos.forEach((memo, idx) => {
            // memo.popup_widget.setOptions({htmlSource: memo.memo_text});
            // 番号が変わるのでマーカ作り変え
            let latlng = memo.marker_widget.getLatLng()
            this.map.removeWidget(memo.marker_widget)
            let marker_widget = this.addSvgPinMarker(idx, latlng, (idx + 1).toString())
            memo.marker_widget = marker_widget
        });

        map_data[index] = {
            ...map_data[index],
            objects: {
                ...map_data[index].objects,
                memos: memos,
            }
        }
        this.setState({map_data: map_data});
    }

    // メモの内容を編集
    onchangeMemo (e, index, mIndex) {
        let content = e.target.value
        let map_data = this.state.map_data
        let tmpError = this.state.error ? this.state.error: [];
        tmpError[`P${index}`] = tmpError[`P${index}`] ? tmpError[`P${index}`] : [];
        if(content.length > 60){
            tmpError[`P${index}`][`M${mIndex}`] = GetMessage("2032");
        }else{
            if(tmpError[`P${index}`][`M${mIndex}`]){
                delete(tmpError[`P${index}`][`M${mIndex}`]);
            }
            if(!Object.keys(tmpError[`P${index}`]).length){
                delete(tmpError[`P${index}`]);
            }
        }

        map_data[index].objects.memos[mIndex].memo_text = content
        map_data[index].objects.memos[mIndex].popup_widget.setOptions({
            htmlSource: content
        });

        this.setState({map_data:map_data,error:tmpError})
    }

    // 図形追加処理
    addPolygon ( e, index ) {
        console.log('### addPolygon' + index);
        let map_data = this.state.map_data
        let {polygonIndex} = map_data[index].settings
        let {polygons} = map_data[index].objects
        const latLng = e.latlng
        let polygon_drawer_options = map_data[index].polygon_drawer_options;

        const svg = `
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
            <circle cx="5" cy="5" r="5" fill="none" stroke="${polygon_drawer_options.strokeColor}" stroke-width="2"></circle>
            <!-- cx=中心のx座標 cy=中心のy座標 r=半径 -->
        </svg>
        `
        const iconSvgUrl = `data:image/svg+xml,${encodeURIComponent(svg)}`;
        let marker = new ZDC.Marker(
            new ZDC.LatLng(latLng.lat, latLng.lng),
            {
                custom: {
                    base: {
                        imgPos: new ZDC.Point(-5, -5),
                        imgSrc: iconSvgUrl
                    }
                }
            }
        );
        this.map.addWidget(marker);
        
        // 追加処理
        let polygon = {}
        if ( polygons.length <= polygonIndex ) {
            // Plygonオブジェクトの生成
            var latlngs = [];
            latlngs.push(new ZDC.LatLng(latLng.lat, latLng.lng))
            polygon = {
                latlngs: latlngs,
                polygon_widget: null,
                marker_widgets: [marker]
            }
            polygons.push(polygon);
        } else {
            polygon = polygons[polygonIndex]
            polygon.latlngs.push(new ZDC.LatLng(latLng.lat, latLng.lng))
            polygon.marker_widgets.push(marker)
            if(polygon.latlngs.length >= 3) {
                if(polygon.polygon_widget == null) {
                    var plg = new ZDC.Polygon(polygon.latlngs, {
                        fill: polygon_drawer_options.fillColor,
                        stroke: polygon_drawer_options.strokeColor,
                        strokeWidth: polygon_drawer_options.strokeWeight,
                        opacity: polygon_drawer_options.fillOpacity,
                        propagation: true
                    });
                    this.map.addWidget(plg);
                    polygon.polygon_widget = plg;
                } else {
                    polygon.polygon_widget.setShape(polygon.latlngs);
                }
            }
        }
        let marker_index = polygon.marker_widgets.length - 1
        marker.addEventListener("mousedown", (e) => {
            console.log('select polygon marker ' + marker_index)
            this.selectPolygon(marker, marker_index, polygon, polygonIndex)
        })

        map_data[index].objects.polygons = polygons
        this.setState({map_data: map_data})
    }

    routeSearch (start, end, relay_points, route_type="walk") {
        // console.log(relay_points.length);
        const max_relay_points = waypointMaxCount;
        if(relay_points.length > max_relay_points) {
            this.props.alertModal.current.showErrorModal({messageNo:2624});
            return new Promise(resolve => { resolve([{status: "error"}]) });
        }
        return new Promise(resolve => {
            let mpoints = relay_points.map((rp) => rp.lng + ',' + rp.lat).join(',');
            const url = `/api/route?route_type=${route_type}&project=${start.lat},${start.lng}&parking=${end.lat},${end.lng}&mpoints=${mpoints}`
            Request.get(url, {}, res => {
                let result = res.Data
      
                resolve(result)
            }
            , () => {
            }
            , undefined
            , false)
        });
    }

    // 経路の描画
    drawDirections(param, index, markers = []) {
        let map_data = this.state.map_data
        let {
            map_drawer_options,
            direction_stroke_options,
            objects,
            isload,
        } = map_data[index];

        let directionStrokeOptions = [...direction_stroke_options]

        let route_polylines = new Array(param.coordinates.distinates)

        const drawDirectionsLiner = param.coordinates.distinates.map((coord, subIndex) => {
            const start = param.coordinates.start;
            const end = coord;
            const relay_points = param.coordinates.relay_points[subIndex];
            const request = {
                origin: start,
                destination: end,
                travelMode: "WALKING"
            };

            let marker;
            let options = (directionStrokeOptions[subIndex]) ? directionStrokeOptions[subIndex] : map_drawer_options
            let num = subIndex + 1
            let strokeColor = options.polylineOptions.strokeColor

            marker = this.addDistinateMarker(
                index,
                subIndex,
                end,
                { text: num.toString() },
                { fillColor: strokeColor, strokeColor: strokeColor }
            )

            // TODO zenrinのルート検索
            this.routeSearch(start, end, relay_points, "walk").then((data) => {
                // console.log(routes);
                // console.log(data);
                var latlngs = [];
                if(data['status'] != 0) {
                    console.log('route error');
                } else {
                    var routes = data['data'];
                    routes.forEach((route) => {
                        latlngs.push(new ZDC.LatLng(route['lat'], route['lng']))
                    });
                }
                var pli = new ZDC.Polyline(
                    latlngs,
                    {
                        color: options.polylineOptions.strokeColor,
                        opacity: options.polylineOptions.strokeOpacity,
                        width: options.polylineOptions.strokeWeight
                    }
                );
                pli.addEventListener('click', (event) => {
                    this.clearSelectWidget();
                });
                pli.addEventListener('mousedown', (event) => {
                    this.selectPolyline(pli, subIndex, event.latlng);
                });
                pli.addEventListener('mouseup', (event) => {
                    this.clearSelectWidget();
                });
                this.map.addWidget(pli);
                route_polylines[subIndex] = pli
                map_data[index].objects.route_polylines = route_polylines;
            });

            return { marker: marker, draw_options: options };
        });
        return drawDirectionsLiner;
    }
    reroute(start, end, relay_points, callback = (latlngs) => {}, errorcallback = () => {}) {
        // console.log(relay_points)
        this.routeSearch(start, end, relay_points, "walk").then((data) => {
            if(data["status"] != 0) {
                errorcallback()
            } else {
                var routes = data['data'];
                var latlngs = [];
                routes.forEach((route) => {
                    latlngs.push(new ZDC.LatLng(route['lat'], route['lng']))
                });
                callback(latlngs)
            }
        })
    }

    controller (setting, index) {
        let listSelectedColor = [...colors];
        let listSelectWeight = [...borderWeights];
        let listSelectOpacity = [...opacities];
        let {
            edit_mode, 
            map_drawer_options,
            direction_stroke_options : direcionStrokeOptions
        } = setting

//        console.log(setting)

        let map_data = this.state.map_data[index]
        let {
            memos,
        }=map_data.objects

        return (<>
            <div className="setting-map">
                <div className="setting-map__item">
                    <h4 className="title">経路の線の編集</h4>
                    {map_data.coordinates.distinates.map((distinate, n)=>{
                        let strokeOption = (direcionStrokeOptions[n])? direcionStrokeOptions[n] : map_drawer_options
                        let num = index * 3 + n

                        return (
                            <div className="group-box group-box-attr">
                            <Row>
                                <Col style={{width:"1em",fontSize:"2em"}}>
                                    {n==0?(<>{aryAlphabet[num]}</>):(<>
                                        {n==1?(<>{aryAlphabet[num]}</>):(<>
                                            {n==2&&(<>{aryAlphabet[num]}</>)}
                                        </>)}
                                    </>)}
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label for="color">色</Label>
                                        <div className="select-box">
                                            <Input
                                                id="color"
                                                name="color"
                                                type="select"
                                                defaultValue={strokeOption.polylineOptions.strokeColor}
                                                value={strokeOption.polylineOptions.strokeColor}
                                                onChange={(e) => this.onChangeHandle("StrokeAttr", e, index, n)}
                                            >
                                                {listSelectedColor.map((option) => (
                                                    <option value={option.value}>{option.label}</option>
                                                ))}
                                            </Input>
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label for="weight">太さ</Label>
                                        <div className="select-box">
                                            <Input
                                                id="weight"
                                                name="weight"
                                                type="select"
                                                defaultValue={strokeOption.polylineOptions.strokeWeight}
                                                value={strokeOption.polylineOptions.strokeWeight}
                                                onChange={(e) => this.onChangeHandle("StrokeAttr", e, index, n)}
                                            >
                                                {listSelectWeight.map((option) => (
                                                    <option value={option.value}>{option.label}</option>
                                                ))}
                                            </Input>
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label for="opacity">透明度</Label>
                                        <div className="select-box">
                                            <Input
                                                id="opacity"
                                                name="opacity"
                                                type="select"
                                                defaultValue={strokeOption.polylineOptions.strokeOpacity}
                                                value={strokeOption.polylineOptions.strokeOpacity}
                                                onChange={(e) => this.onChangeHandle("StrokeAttr", e, index, n)}
                                            >
                                                {listSelectOpacity.map((option) => (
                                                    <option value={option.value}>{option.label}</option>
                                                ))}
                                            </Input>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </div>                        )
                    })}
                </div>
                <div className="setting-map__item">
                    <h4 className="title">図形の描画</h4>
                    <div className="group-box">
                        <Button
                            color="primary"
                            onClick={() => this.onClickHandle("AddPolygon",index)}
                            disabled={edit_mode != MODE_POLYGON}
                        >
                            図形追加
                        </Button>
                        &emsp;
                        <Button
                            color="primary"
                            onClick={() => this.onClickHandle("RollbackPolygon",index)}
                        >
                            一つ戻す
                        </Button>
                        &emsp;
                        <Button
                            color="primary"
                            onClick={() => this.onClickHandle("ResetPolygon",index)}
                        >
                            リセット
                        </Button>
                    </div>
                </div>

                {/* メモ欄の追加 */}
                <div className="setting-map__item">
                    <h4 className="title">メモ欄の追加</h4>
                    <div className="group-box mb-3">
                        <Button
                            color="primary"
                            onClick={() => this.onClickHandle("AddMemo",index)}
                        >
                            メモ追加
                        </Button>
                    </div>
                    <div className="group-memo">
                    {memos.map( (memo, mIndex) => {
                            return (
                                <>
                                <FormGroup key={index+"-"+mIndex}>
                                        <table width="100%">
                                            <tr>
                                                <td width="50">
                                                    <Label for={`memo-${index}-${mIndex}`}>
                                                        メモ{mIndex + 1}
                                                    </Label>
                                                </td>
                                                <td>
                                                    <Input
                                                        id={`memo-${index}_${mIndex}`}
                                                        name={`memo-${index}_${mIndex}`}
                                                        placeholder="メモを入力してください"
                                                        value={memo.memo_text}
                                                        onChange={(e) => this.onchangeMemo(e, index, mIndex)}
                                                    />
                                                </td>
                                                <td width="50" align="center">
                                                    <div className="delete" onClick={() => this.deleteMemo(index, mIndex)}>
                                                        <img src={require("assets/img/icon-dust.jpeg")} width="30" height="30" alt="" />
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                </FormGroup>
                                {this.state.error[`P${index}`] && this.state.error[`P${index}`][`M${mIndex}`] && <div style={{color:"red"}}>{this.state.error[`P${index}`][`M${mIndex}`]}</div>}
                                </>
                            )
                        }
                    )}
                    </div>
                </div>
                <div className="setting-map__item">
                    <div className="group-box group-box-grid">
                        <Button
                            color="primary"
                            onClick={() => this.onClickHandle("Preview",index)}
                        >
                            経路図プレビュー
                        </Button>

                        <Button
                            color="primary"
                            onClick={() => this.onClickHandle("GetUrl",index)}
                        >
                            URL取得
                        </Button>
                    </div>
                </div>
            </div>
    </>)
    }
    onClickHandle (target, index) {
        let {
            objects,
            settings
        }=this.state.map_data[index]
        // console.log("onClickHandle " + target + " " + index);
        switch (target) {
            case "AddPolygon":{
                let {polygonIndex} = settings
                let len = objects.polygons.length
                if ((polygonIndex+1) == len) {
                    let map_data = this.state.map_data
                    let mapData = {
                        ...this.state.map_data[index],
                        settings: {
                            ...settings,
                            polygonIndex : polygonIndex+1
                        }
                    }
                    map_data[index] = {...mapData}

                    this.setState({ map_data : map_data });
                }
            }break
            case "ResetPolygon":{
                if ( objects.polygons.length > 0 ) {
                    objects.polygons.map((polygon, n)=>{
                        if(polygon.polygon_widget != null) {
                            this.map.removeWidget(polygon.polygon_widget)
                        }
                        polygon.marker_widgets.map((marker_widget) => {
                            this.map.removeWidget(marker_widget)
                        })
                    })
                    objects.polygons = []
                    let map_data = this.state.map_data
                    let mapData = {
                        ...this.state.map_data[index],
                        settings: {
                            ...settings,
                            polygonIndex : 0
                        },
                        objects: objects
                    }
                    map_data[index] = {...mapData}

                    this.setState({ map_data : map_data });
                }
            }break
            case "RollbackPolygon": {
                if ( objects.polygons.length > 0 ) {
                    let map_data = this.state.map_data
                    let editIndex = objects.polygons.length - 1;
                    let polygon = objects.polygons[editIndex];

                    if (polygon.latlngs.length <= 1) {
                        if(polygon.polygon_widget != null) {
                            this.map.removeWidget(polygon.polygon_widget)
                        }
                        polygon.marker_widgets.map((marker_widget) => {
                            this.map.removeWidget(marker_widget)
                        })
                        objects.polygons.pop()
                        map_data[index].settings.polygonIndex -= 1
                    } else {
                        polygon.latlngs.pop()
                        var marker = polygon.marker_widgets.pop()
                        this.map.removeWidget(marker);
                        if(polygon.latlngs.length < 3) {
                            if(polygon.polygon_widget != null) {
                                this.map.removeWidget(polygon.polygon_widget)
                            }
                            polygon.polygon_widget = null
                        } else {
                            if(polygon.polygon_widget != null) {
                                polygon.polygon_widget.setShape(polygon.latlngs)
                            }
                        }
                    }
                    map_data[index].objects = objects

                    this.setState({map_data: map_data})
                }
            }break;
            case "AddMemo":{
                this.addMemo(index)
            }break
            case "RemoveMemo":{

            }break
            case "Preview": {
                this.setState({
                    modal_monochrome_map: true,
                    modal_map_index: index
                })
            }break;
            case "GetUrl": {
                this.setState({
                    confirm_map_url: true
                })
            }break;
        }
    }
    onChangeHandle (target, e, index, subIndex=0) {
        let {
            map_data
        } = this.state
        let isReload = false // 地図再読み込みフラグ

        switch (target) {
            case "ShapeType":{
                map_data[parseInt(index)] = {
                    ...this.state.map_data[parseInt(index)],
                    edit_mode : parseInt(e.target.value)
                }
            }break;
            case "StrokeAttr":{
                let attr = "";
                isReload = true

                let {
                    direction_stroke_options
                }=map_data[parseInt(index)]

                switch (e.target.name) {
                    case "color":{
                        attr = "strokeColor";
                    }break;
                    case "weight":{
                        attr = "strokeWeight";
                    }break;
                    case "opacity":{
                        attr = "strokeOpacity";
                    }break;
                }

                if (direction_stroke_options[subIndex]) {
                    direction_stroke_options[subIndex] = {
                        ...direction_stroke_options[subIndex],
                        polylineOptions : {
                            ...direction_stroke_options[subIndex].polylineOptions,
                            [attr] : e.target.value
                        }
                    }
                }

                map_data[parseInt(index)] = {
                    ...this.state.map_data[parseInt(index)],
                    direction_stroke_options: direction_stroke_options
                }
            }break;
        }

        let route_polylines = map_data[index].objects.route_polylines;
        let options = map_data[index].direction_stroke_options;
        route_polylines.map((route_polyline, n) => {
            route_polyline.setOptions({
                color: options[n].polylineOptions.strokeColor,
                opacity: options[n].polylineOptions.strokeOpacity,
                width: options[n].polylineOptions.strokeWeight
            });
        });

        this.setState({
            map_data : map_data
        },()=>{});
    }
    calcDistance(project, parking, mpoints,request_type){
        return new Promise(resolve => {
          const url = `/api/calcdistance?project=${project.lat},${project.lon}&parking=${parking.lat},${parking.lon}&mpoints=${mpoints}&request_type=${request_type}`
    
            Request.get(url, {}, res => {
                let {site_distance_meter,site_distance_minute } = res.Data

                resolve({site_distance_meter, site_distance_minute})
            }
            , () => {
                this.props.alertModal.current.showErrorModal({messageNo:2477});
            }
            , undefined
            , false)
        })
    }
    async save () {
        if(this.state.error.P0 ||
           this.state.error.P1 || 
           this.state.error.P2 ||
           this.state.error.P3 ||
           this.state.error.P4
        ){
            this.props.alertModal.current.showErrorModal({messageNo:2401});
            return ;
        }
        Request.setProgress(20,"地図データ保存中");
        let unloadId = ()=> {
            let array_id = []
            this.state.map_data.forEach((map, index)=>{
                if (map.isload===false) {
                    array_id.push(index)
                }
            })
            return array_id;
        }

        let id = unloadId();
//        console.log(id);

        if ( id.length>0 ) {
            this.onchangeMapIndex(id[0]);
            return;
        }
        Request.setProgress(30,"地図データ保存中");

        if (this.props.callbackSaved) {
            let destinates = []
            let objects = []
            for(let index = 0; index < this.state.map_data.length; index++) {
                let md = this.state.map_data[index];

            // let objects = this.state.map_data.map(async (md, index)=>{
                let directions = await this.convert_object_direction(index)
                md.coordinates.distinates.map((item, n)=>{
                    let {direction} = directions[n]
                    directions[n].request_parking_ulid = item.data.request_parking_ulid
                    destinates.push({
                        ...direction,
                        request_parking_ulid: item.data.request_parking_ulid,
                    })
                })
                objects.push({
                    "monochrome_map_url":this.staticmapUrl(index, true),
                    "objects": {
                        base_map : this.convert_map_object(index),
                        markers : this.convert_object_marker(index),
                        directions : directions,
                        polygons : this.convert_object_polygon(index),
                        memos: this.convert_object_memo(index), 
                    }
                })
            }
            Request.setProgress(80,"地図データ保存中");

            if(this.state.url_error == true){
                Request.setProgress(0);
                this.props.alertModal.current.showErrorModal({messageNo:2623});
            }else{
                Request.setProgress(100);
                this.props.callbackSaved(objects, destinates)
            }
        }
    }

    convert_map_object(index) {
        let {map_settings} = this.state.map_data[index]

        return {
            size: {
                width: baseMapSize.width,
                height: baseMapSize.height
            },
            scale: "1",
            language: "ja",
            center: {
                lat: map_settings.center.lat,
                lng: map_settings.center.lng
            },
            zoom : map_settings.zoom,
            style:[
                {
                    feature:"water",
                    element:"geometry.fill",
                    color:"#ffffff"
                },
                {
                    feature:"water",
                    element:"geometry.stroke",
                    color:"#000000"
                },
                {
                    feature:"landscape.natural",
                    element:"geometry.fill",
                    color:"#ffffff"
                },
                {
                    feature:"landscape.man_made",
                    element:"geometry.fill",
                    color:"#ffffff"
                },
                {
                    feature:"landscape.man_made",
                    element:"geometry.stroke",
                    color:"#000000"
                },
                {
                    feature:"poi",
                    element:"geometry.fill",
                    color:"#ffffff"
                },
                {
                    feature:"road.highway",
                    saturation:"-100%",
                    lightness:"50%"
                },
                {
                    feature:"poi",
                    element:"labels",
                    visibility:"off"
                },
                {
                    feature:"landscape.man_made",
                    element:"labels.icon",
                    visibility:"off"
                },
                {
                    feature:"road",
                    element:"geometry.stroke",
                    color:"#000000"
                },
           ]
        }
    }

    convert_map_param(index, arrayflag=true) {
        if (this.map == null) {
            return
        }

        let zoom;
        let center;
        if ( this.state.view_index == index ) {
            zoom = this.map.getZoom();
            center = {
                lat : this.map.getCenter().lat,
                lng : this.map.getCenter().lng
            }
        }
        else {
            center = this.state.map_data[index].map_settings.center
            zoom = this.state.map_data[index].map_settings.zoom
        }


        let arrayUrl = []
        arrayUrl.push("size="+baseMapSize.width + "," + baseMapSize.height)
        arrayUrl.push("center="+center.lat+","+center.lng)
        arrayUrl.push("zoom="+zoom)
        return (arrayflag)? arrayUrl: "&" + arrayUrl.join("&")
    }

    convert_object_marker (index) {
        let {
            markers
        } = this.state.map_data[index].objects

        let rtnObject = []

        if (markers.length==0) return "" 

        markers.forEach((marker)=>{
            rtnObject.push({
                start: marker.start, // 現場ならtrue, flaggedならfalse
                lat: marker.marker.getLatLng().lat,
                lng: marker.marker.getLatLng().lng,
                request_parking_status: (marker.start ? "" : marker.request_parking_status) // flaggedのときだけ有効
            })
        })
        return rtnObject
    }
    convert_uri_marker (index, arrayflag = true) {
        let {
            markers
        } = this.state.map_data[index].objects

        let rtnObject = []

        if (markers.length==0) return "" 

        markers.forEach((marker)=>{
            rtnObject.push(
                "marker=" 
                + marker.marker.getLatLng().lat
                + ',' + marker.marker.getLatLng().lng
                + "|" + (marker.start ? "start" : "flagged")
                + "|" + (marker.start ? "" : marker.request_parking_status)
                + "|"
            )
        })

       return "&" + rtnObject.join("&")

        // return (arrayflag)? rtnObject : "&" + rtnObject.join("&")
    }

    async convert_object_direction (index) {
        let {
            objects,
            map_drawer_options: options,
            direction_stroke_options,
            coordinates
        }=this.state.map_data[index]
        // console.log(this.state.map_data[index])
        let {
            distinates_markers,
            route_polylines,
        } = objects

        let rtnObject = []

        if (distinates_markers.length==0) return ""

        // distinates_markers.forEach(async (marker, idx)=>{
        for(let idx = 0; idx < distinates_markers.length; idx++ ) {
            let marker = distinates_markers[idx];
            let {
                strokeWeight,
                strokeColor,
                strokeOpacity
            } = direction_stroke_options[idx].polylineOptions

            let cnt = index * 3 + idx
            let color = strokeColor
            let text =  aryAlphabet[cnt]
            let waypoints = []
            let distance = null

            let project = {lat:coordinates.distinates[idx].lat,lon:coordinates.distinates[idx].lng}
            let parking = {lat:coordinates.start.lat,lon:coordinates.start.lng}
            let mpoints = ""
            coordinates.relay_points[idx].length > 0 && coordinates.relay_points[idx].forEach((rp)=>{
                mpoints += mpoints.length == 0 ? String(rp.lng) + "," + String(rp.lat) : "," +String(rp.lng) + "," + String(rp.lat) 
            })
            // console.log(coordinates,project,parking,mpoints,this.props.request_data.request_type)

            let result = await this.calcDistance(project, parking, mpoints,this.props.request_data.request_type);
            // console.log(result)
            distance = result;
            let route_polyline = route_polylines[idx]
            if(route_polyline != null) {
                let shape = route_polyline.getShape()
                // console.log(shape)
                shape.forEach((latlng) => {
                    waypoints.push({ Lat: latlng.lat, Lng: latlng.lng });
                })
            }
            rtnObject.push({
                direction : {
                    color : strokeColor,
                    weight : strokeWeight,
                    opacity : strokeOpacity,
                    points : [...waypoints] ,
                    markers : {
                        text: text,
                        color : color, 
                        lat: marker.getLatLng().lat,
                        lng: marker.getLatLng().lng,
                    },
                    distance : distance
                }
            })
        }

        return rtnObject       
    }

    convert_uri_direction (index, arrayflag=true) {
        let {
            objects,
            map_drawer_options: options,
            direction_stroke_options
        }=this.state.map_data[index]
        let {
            distinates_markers,
            route_polylines
        } = objects

        let rtnArray = []

        distinates_markers.forEach((marker, idx)=>{
            let color = direction_stroke_options[idx].polylineOptions.strokeColor
            let cnt = index * 3 + idx

            rtnArray.push(
                "marker="
                + marker.getLatLng().lat
                + ',' + marker.getLatLng().lng
                + "|distinate"
                + "|" + aryAlphabet[cnt]
                + "|" + color.replace("#", "0x"))
        })

        route_polylines.forEach((route_polyline, idx)=>{
            if(route_polyline == null) return;
            let direction_stroke_option = direction_stroke_options[idx]
            let color = direction_stroke_option.polylineOptions.strokeColor
            let opacity = direction_stroke_option.polylineOptions.strokeOpacity
            let width = direction_stroke_option.polylineOptions.strokeWeight
            let shape = route_polyline.getShape()
            
            let latlngs = shape.map((latlng) => latlng.lat + "," + latlng.lng).join(' ')
            rtnArray.push(
                "line="
                + latlngs
                + "|" + color.replace("#", "0x")
                + "|" + width
                + "|" + opacity)
        })
        return "&" + rtnArray.join("&")
    }

    convert_object_polygon (index) {
        let {
            polygons,
        } = this.state.map_data[index].objects
        let polygon_drawer_options = this.state.map_data[index].polygon_drawer_options;

        let rtnArrayObject = []

        polygons.forEach((polygon, index)=>{
            let {
                polygon_widget,
            }=polygon
            let arrayCoords = []
            if(polygon_widget == null) return
            let shape = polygon_widget.getShape()
            // 図形の緯度経度情報を取得
            shape.forEach((latLng)=>{
                arrayCoords.push({
                    lat: latLng.lat,
                    lng: latLng.lng
                })
            })
            rtnArrayObject.push({
                polygon: {
                    color: polygon_drawer_options.strokeColor,
                    fillcolor: polygon_drawer_options.fillColor,
                    opacity: polygon_drawer_options.fillOpacity,
                    weight: polygon_drawer_options.strokeWeight,
                    points:arrayCoords
                }
            })
        })
        // console.log(rtnArrayObject)
        return rtnArrayObject
    }
    convert_uri_polygon (index, arrayflg = true) {
        let {
            polygons,
        } = this.state.map_data[index].objects
        let polygon_drawer_options = this.state.map_data[index].polygon_drawer_options;

        let rtnArray = []

        if (polygons.length == 0) return "" 

        polygons.forEach((polygon, index)=>{
            let {
                polygon_widget,
            }=polygon

            if(polygon_widget == null) return;

            let shape = polygon_widget.getShape()
            let latlngs = shape.map((latlng) => latlng.lat + "," + latlng.lng).join(' ')
            rtnArray.push(
                "polygon="
                + latlngs
                + "|" + polygon_drawer_options.strokeColor.replace("#", "0x")
                + "|" + polygon_drawer_options.strokeWeight
                + "|" + polygon_drawer_options.fillColor.replace("#", "0x")
                + "|" + polygon_drawer_options.fillOpacity)
        })

        return "&" + rtnArray.join("&")
    }
    convert_object_memo (index) {
        let {
            memos,
        } = this.state.map_data[index].objects

        let rtnArrayObject = []
        if (memos.length==0) return rtnArrayObject

        memos.forEach((memo,index)=>{
            let marker = memo.marker_widget
            let text = memo.memo_text
            let marker_index = index + 1

            rtnArrayObject.push({
                memo : {
                    marker : {
                        text : marker_index.toString(),
                        lat: marker.getLatLng().lat,
                        lng: marker.getLatLng().lng,
                    },
                    contents: text
                }
            })
        })
        return rtnArrayObject;
    }
    convert_uri_memo (index, arrayflg = true) {
        let {
            memos,
        } = this.state.map_data[index].objects

        if (memos.length==0) return ""

        let rtnArray = []

        memos.forEach((memo,index)=>{
            let marker = memo.marker_widget
            let text = memo.memo_text
            let marker_index = index + 1

            rtnArray.push(
                "marker="
                + marker.getLatLng().lat
                + ',' + marker.getLatLng().lng
                + "|memo"
                + "|" + marker_index
                + "|" + text
            )
        })
        return "&" + rtnArray.join("&")
    }

    parkingDetail (parkings, index) {
        return (<>
            {parkings.map(
                (parking, subIndex)=>{
                    let num = index * 3 + subIndex + 1;
                    return(<>
                        <div className="list-parking-detail__item">
                        <h4 className="title">
                            駐車場<span className="number">{num}</span>
                        </h4>
                        <div className="detail-info">
                            <Row>
                                <Col lg="6">
                                    <div className="detail-info__table">
                                        <div className="item item-parking">
                                            <div className="item__left">
                                                <span>駐車場名</span>
                                            </div>
                                            <div className="item__right">
                                                <span>{parking.data.parking_name}</span>
                                                <span>現場からの距離</span>
                                                <span>18分</span>
                                            </div>
                                        </div>

                                        <div className="item item-vehicle-size">
                                            <div className="item__left">
                                                <span>車両サイズ</span>
                                            </div>
                                            <div className="item__right text-center">
                                                <span>ワゴン：{parking.data.capacity_flag_car}台</span>
                                                <span>軽トラ：{parking.data.capacity_flag_light_truck}台</span>
                                                <span>2t：{parking.data.capacity_flag_truck}台</span>
                                                {/*<span>その他：{parking.capacity_flag_other}台</span>*/}
                                            </div>
                                        </div>
                                        {/*
                                        <div className="item item-daily-rate">
                                            <div className="item__left">
                                                <span>日割</span>
                                            </div>
                                            <div className="item__right">
                                                <span>日割開始月：×</span>
                                                <span>日割終了月：×</span>
                                                <span>一月単位の計算：×</span>
                                            </div>
                                        </div>
                                        */}
                                        <div className="item item-remarks">
                                            <div className="item__left">
                                                <span>特記事項</span>
                                            </div>

                                            <div className="item__right text-center">
                                                <span>現在 1 台分空有</span>
                                            </div>
                                        </div>

                                        <div className="item item-image">
                                            <div className="box-img text-center">
                                                <img src={parking.data.picture} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                <Col lg="6">
                                    <div id={`DetailMap-${num}`} className="detail-info__map"/>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    </>)
                }
            )
        }
        </>);
    }
    staticmapUrl ( index, check=false) {

        let baseUrl = location.protocol + "//" + location.host + "/api/mapimage?"
        let param =  this.convert_map_param( index, false )
        + this.convert_uri_marker( index, false )
        + this.convert_uri_direction( index, false )
        + this.convert_uri_memo( index, false )
        + this.convert_uri_polygon( index, false )
        if(check == true){
            // console.log(index)
            this.urlValidate(param)
        }
        return encodeURI(baseUrl + param)
    }
    urlValidate(param){
        const length_size_max = urlMaxLength

        const length_error = param.length > length_size_max

        if( this.state.url_error !== length_error && this.state.url_error == false){
            
            this.setState({url_error:length_error})
        }
    }
    copyToClipboard() {
        let element = document.getElementById("googleMapsUrl")
        navigator.clipboard.writeText(element.value).then(()=>{
//            console.log("copy success");
            window.alert("コピーしました。")
        },(err)=>{
//            console.log("copy failed");
        })
    }
    onClickMapHandle (e) {
        let index = this.state.view_index;
        let {
            objects,
            edit_mode
        } = this.state.map_data[index]
        // 緯度経度情報
        const coord = e.latlng
//        console.log(coord, edit_mode);

        switch ( edit_mode ) {
            case MODE_GRAB:{

            }break;
            case MODE_MARKER:{

            }break;
            case MODE_POLYGON:{
                this.addPolygon(e,index)
            }break;
        }
    }
    onchangeMapIndex (index) {
        Request.setProgress(20,"地図読み込み中")
        let {map_data} = this.state
        let hideMapData = this.state.map_data[this.state.view_index]

        let zoom = this.map.getZoom()
        let lat = this.map.getCenter().lat
        let lng = this.map.getCenter().lng
        hideMapData.map_settings = {
            ...hideMapData.map_settings,
            center: {
                lat : lat,
                lng : lng
            },
            zoom: zoom
        }
        map_data[this.state.view_index] = hideMapData;

        let {
            markers,
            distinates_markers,
            polygons,
            memos,
            route_polylines,
        } = hideMapData.objects
        markers.map((m) => m.marker.hide())
        distinates_markers.map((dm) => dm.hide())
        // direction_renders.map((dr)=>dr.setMap(null))
        polygons.map((p)=> {
            p.marker_widgets.map((m) => m.hide())
            if(p.polygon_widget != null) {p.polygon_widget.hide()}
        })
        memos.map((m) => {
            m.popup_widget.hide()
            m.marker_widget.hide()
        })
        route_polylines.map((rp) => rp.hide());

        this.setState({
            map_data: map_data
        },()=>{
            let data = this.state.map_data[index]

            if ( data.isload === false ) {
                this.loadMapView(index);
            }
            else {
                let {
                    distinates_markers, // 目的地アイコン
                    markers,
                    polygons,
                    memos,
                    route_polylines
                } = data.objects
                markers.map((m) => m.marker.show())
                distinates_markers.map((dm)=>dm.show())
                // direction_renders.map((dr)=>dr.setMap(map))
                polygons.map((p)=>{
                    p.marker_widgets.map((m) => m.show())
                    if(p.polygon_widget != null) {p.polygon_widget.show()}
                })
                memos.map((m)=>{
                    m.popup_widget.show()
                    m.marker_widget.show()
                })
                route_polylines.map((rp) => rp.show());

                this.map.setCenter(new ZDC.LatLng(data.map_settings.center.lat, data.map_settings.center.lng));
                this.map.setZoom(data.map_settings.zoom);
            }

            this.setState({
                view_index:index,
            })
        })
        setTimeout(()=>{Request.setProgress(80,"地図読み込み中")},500)
        setTimeout(()=>{Request.setProgress(0,"地図読み込み中")},1000)
    }
    render () {
        let {map_data, request_data, map_settings} = this.state
        let param = map_data[this.state.view_index]
//        console.log((this.state.map_data.filter((mapData)=>mapData.isload===false).length>0))
        let baseUrl = "https://www.google.com/maps/dir/?api=1&travelmode=walking" // QRコード用URL生成用パラメータ
//        let {map} = this.state.googleMaps
//        let center = map?{lat: map.getCenter().lat(), lng: map.getCenter().lng()} : undefined
        let {center} = map_settings
        return (<>
            <div className="content route-map">
                <Row>
                    <Col md="12">
                        <Card>
                            <CardHeader>
                                <CardTitle tag="h3">経路図編集</CardTitle>
                            </CardHeader>
                            <CardBody>
                                <Row className="tab-menu">
                                {map_data && (
                                    map_data.map((objects, index)=>{
                                        return(<div className={(this.state.view_index==index)?"on":""} onClick={()=>{this.onchangeMapIndex(index)}}>
                                            {index+1}
                                        </div>)
                                    })
                                )}
                                </Row>
                                <div className="info mb-4">
                                    <div className="info__item">
                                        <span>工事番号</span>
                                        <span>{request_data.project_natural_id}</span>
                                    </div>
                                    <div className="info__item">
                                        <span>現場名</span>
                                        <span style={{wordBreak: "break-all"}}>{request_data.site_name}</span>
                                    </div>
                                </div>
                                <div className="parking-route">
                                    <div className="parking-route__info">
                                        <Row>
                                            <Col style={{width:(baseMapSize.width + 10)+"px"}}>
                                                <div id="MapDiv" className="map-polygon" style={{width:baseMapSize.width+"px",height:baseMapSize.height+"px"}}/>
                                            </Col>
                                            <Col>
                                                {this.controller(param,this.state.view_index)}
                                                <div>
                                                    <table className="parkingDetailInfo">
                                                    {param.coordinates.distinates.map((dist, n)=>{
                                                        let num = this.state.view_index * 3 + n;
                                                        let dm = param.objects.distinates_markers[n]
                                                        let mapUrl = ""
                                                        if (dm) {
                                                            let coord = {lat:dm.getLatLng().lat, lng:dm.getLatLng().lng}
                                                            mapUrl = baseUrl+`&origin=${center.lat},${center.lng}&destination=${coord.lat},${coord.lng}`
                                                        }
                                                        return(<tr>
                                                            <th>{aryAlphabet[num]}</th>
                                                            <td>
                                                                {dist.data.parking_name}&nbsp;
                                                                {center && (<>
                                                                    <div class="google-map-url">{mapUrl}</div>&nbsp;
                                                                    <CopyToClipboard text={mapUrl} onCopy={()=>{window.alert("コピーしました。")}}>
                                                                        <button>コピー</button>
                                                                    </CopyToClipboard>
                                                                </>)}
                                                            </td>
                                                        </tr>)
                                                    })}
                                                    </table>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div style={{textAlign:"center"}}>
                                        <Button color="primary" onClick={()=>this.save()}>
                                            {(this.state.map_data.filter((mapData)=>mapData.isload===false).length>0)? "次へ":"保存"}
                                        </Button>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            <Modal isOpen={this.state.modal_monochrome_map} className="modalMonochromeMap">
                <ModalBody>
                    <img style={{width:baseMapSize.width+"px",height:baseMapSize.height+"px"}} src={this.staticmapUrl(this.state.modal_map_index, false)} alt="zenrinstaticmap" />
                </ModalBody>
                <ModalFooter>
                    <Button style={{margin:"auto"}} onClick={()=>{this.setState({modal_monochrome_map:false})}}>閉じる</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.confirm_map_url}  className="">
                <ModalBody>
                    <textarea id="googleMapsUrl" name="googleMapsUrl" rows="10" cols="65" readonly value={this.staticmapUrl(this.state.view_index, false)}>
                        {this.staticmapUrl(this.state.view_index, false)}
                    </textarea>
                    <div>URL文字数：{this.staticmapUrl(this.state.view_index, false).length}文字</div>
                    {this.staticmapUrl(this.state.view_index, false).length > urlMaxLength && (
                        <div style={{color:"red"}}>{GetMessage("2623")}</div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button style={{margin:"auto"}} onClick={()=>{this.copyToClipboard()}}>URLコピー</Button>
                    <Button style={{margin:"auto"}} onClick={()=>{this.setState({confirm_map_url:false})}}>閉じる</Button>
                </ModalFooter>
            </Modal>
        </>);
    }
}
